import { selectAssetArticles, selectTitleDetail } from '@repo/api-adapters/selectors/cart.selectors';
import { translate } from '@repo/phrase';
import { NoBodyMessage } from '@repo/ui/message';
import { Paragraph } from '@repo/ui/typography';

import { ArticleCard } from '@/components/article-table/article-card';
import { ArticleTitle } from '@/components/article-table/article-title';

import { useAsset, useAssetParams } from '@/hooks/asset.hooks';
import { getAssetArticleKey } from '@/utils/article.utils';

import { LoadingPage } from '../loading';
import { QueryError } from '../query-error';

import styles from './styles.module.scss';

const tableHeader = [
    { key: crypto.randomUUID(), text: 'article_table_quantity' },
    { key: crypto.randomUUID(), text: 'article_table_name' },
    { key: crypto.randomUUID(), text: 'article_table_article_number' },
    { key: crypto.randomUUID(), text: 'article_table_unit_price' },
    { key: crypto.randomUUID(), text: 'article_table_total_price' },
];

export const ArticleTable = () => {
    const { assetType, assetId } = useAssetParams();
    const { data, isError, isLoading, error } = useAsset(assetType, assetId);

    if (isLoading) {
        return <LoadingPage />;
    }

    if (isError && !data) {
        return <QueryError error={error} />;
    }

    const items = selectAssetArticles(data);

    if (items.length === 0) {
        return (
            <NoBodyMessage title={translate('article_not_found_title')} body={translate('article_not_found_body')} />
        );
    }

    const titleDetail = selectTitleDetail(data);

    return (
        <div data-testid={`article-table-${assetType}`} className={styles.article_table}>
            <ArticleTitle titleDetail={titleDetail} />
            <div className={styles.table}>
                <div className={styles.article_table_header}>
                    {tableHeader.map((headerItem) => (
                        <div key={headerItem.key}>
                            <Paragraph bodySize="s">{translate(headerItem.text)}</Paragraph>
                        </div>
                    ))}
                </div>
                {items.map((item) => (
                    <ArticleCard item={item} key={getAssetArticleKey(item)} />
                ))}
            </div>
        </div>
    );
};
